import { render, staticRenderFns } from "./RejectRemarkPoDialog.vue?vue&type=template&id=67ee2208"
import script from "./RejectRemarkPoDialog.vue?vue&type=script&lang=js"
export * from "./RejectRemarkPoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports